var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCelery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 63,
    fill: "none",
    viewBox: "0 0 73 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.134 6.5a4.787 4.787 0 0 0-4.798 4.798v40.404a4.787 4.787 0 0 0 4.798 4.798h40.404a4.787 4.787 0 0 0 4.798-4.798V11.298A4.786 4.786 0 0 0 56.538 6.5H16.134Zm17.035 6.4c8.538 0 14.642 2.996 16 3.675l-2.487 5.313c-5.088-2.203-10.402-2.938-11.817-2.938-3.28 0-4.52 1.92-4.52 3.673v17.696c0 1.81 1.24 3.731 4.52 3.731 1.415 0 6.73-.792 11.817-2.938l2.487 5.2c-.906.565-7.577 3.788-16 3.788-2.316 0-9.666-.508-9.666-9.667V22.57c0-9.16 7.35-9.669 9.666-9.669Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.336 6.5h50v50h-50z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelery);
export default __webpack_public_path__ + "static/media/celery.c212591e6fdc8fb6b8f0dde18efd7318.svg";
export { ForwardRef as ReactComponent };